import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IEecsTransaction, IEecsTransactionModal } from '../types/eecs-transaction.type';

export interface EecsTransactionInitialState extends BaseDataReducerV2InitialState<IEecsTransaction> {
  perPage: number;
  selectedTransaction: IEecsTransaction | null;
  currentModal: IEecsTransactionModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<IEecsTransaction, EecsTransactionInitialState>(
  'necs-transaction',
);

export const eecsTransactionInitialState: EecsTransactionInitialState = {
  ...initialState,
  perPage: 25,
  selectedTransaction: null,
  currentModal: null,
};

export const eecsTransaction = createSlice({
  name: 'eecsTransaction',
  initialState: eecsTransactionInitialState,
  reducers: {
    setSelectedEecsTransaction: (state, action: PayloadAction<IEecsTransaction | null>) => {
      state.selectedTransaction = action.payload;
    },
    setEecsTransactionModal: (state, action: PayloadAction<IEecsTransactionModal | null>) => {
      state.currentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as EecsTransactionInitialState, action);
    });
  },
});

export const EecsTransactionAC = AC;
export const onEecsTransactionSort = thunks.onSort;
export const onEecsTransactionFilter = thunks.onFilter;
export const setEecsTransactionCurrentPage = AC.setCurrentPage;

export const { setSelectedEecsTransaction, setEecsTransactionModal } = eecsTransaction.actions;
